import { makeStyles } from '@material-ui/core';
import { useState } from 'react';
import { OptionsType } from 'react-select';

const useStyles = makeStyles({
  option: {
    fontSize: 13,
    fontFamily: 'Roboto',
    fontWeight: 400,
    color: '#aaa',
    cursor: 'pointer',
    flex: 1,
    height: 48,
    textAlign: 'center',
    lineHeight: '48px',
    padding: '0 12px',
    whiteSpace: 'nowrap',
    transition: 'color 0.15s',
    position: 'relative',
    userSelect: 'none',
    WebkitTapHighlightColor: 'transparent',
    '&:hover': {
      color: '#888',
    },
    '&:active': {
      color: '#555',
    },
    '&:not(:last-child)::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      top: '25%',
      height: '50%',
      width: 1,
      backgroundColor: '#e8e8e8',
    },
  },
  option__selected: {
    color: '#555',
    '&:hover': {
      color: '#555',
    },
  },
  option__container: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: 16,
    backgroundColor: 'white',
    width: '100%',
  },
});

const ViewSelect = ({
  options,
  onChange,
  defaultValue = null,
  onHover,
}: {
  options: OptionsType;
  onChange: (...args: any[]) => void;
  defaultValue: any;
  onHover?: (option: any) => void;
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(defaultValue);


  return (

    <div className={classes.option__container}>

      {options.map(option => (<div key={option.value} className={classes.option + ' ' + (value.value === option.value ? classes.option__selected : '')} onClick={() => { onChange(option); setValue(option) }} onMouseEnter={() => onHover?.(option)}>{option.label}</div>))}
    </div>
  );
};

export default ViewSelect;
